import React from 'react'
import BackButton from '../components/BackButton'
import { FaDatabase, FaHandshake, FaInfo, FaShieldAlt } from 'react-icons/fa'

const PrivacyPolicy = () => {
  const policyCards = [
    {
      icon: <FaShieldAlt className='text-white text-2xl' />,
      bgColor: 'bg-teal-500',
      title: 'Your Privacy Matters to Us',
      description: 'At RTO-BHARAT, we respect your privacy and are committed to protecting your personal information.'
    },
    {
      icon: <FaInfo className='text-white text-2xl' />,
      bgColor: 'bg-blue-500',
      title: 'Information We Collect',
      description: 'We collect basic personal details only for the purpose of providing application assistance and related support services. Information shared by users is used strictly for service delivery and internal communication.'
    },
    {
      icon: <FaDatabase className='text-white text-2xl' />,
      bgColor: 'bg-purple-500',
      title: 'How We Handle Your Data',
      description: 'We do not sell, trade, or share personal data with third parties except where required for service completion or legal compliance.'
    },
    {
      icon: <FaHandshake className='text-white text-2xl' />,
      bgColor: 'bg-green-500',
      title: 'Your Consent',
      description: 'By using our website, you consent to the collection and use of information as outlined in this policy.'
    }
  ];

  return (
    <div className='min-h-[calc(100vh-70px)] p-8 flex flex-col items-center bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100'>
      {/* Back Button */}
      <div className='w-full'>
        <BackButton />
      </div>
      
      <h2 className='text-4xl font-bold mb-3 text-center'>Privacy Policy</h2>
      <div className='mt-0 w-[200px] h-1 bg-yellow-500 mx-auto rounded'></div>
      
      <div className='max-w-7xl mt-10'>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-8'>
          {policyCards.map((card, index) => (
            <div key={index} className='relative'>
              {/* Card Container */}
              <div className='bg-white dark:bg-gray-800 rounded-2xl p-6 h-full shadow-lg hover:shadow-xl transition-shadow'>
                {/* Curved Bracket - Top Right */}
                <div className='absolute -top-4 -right-4 w-8 h-8 border-t-4 border-r-4 border-gray-300 dark:border-gray-600 rounded-tr-3xl'></div>
                
                {/* Curved Bracket - Bottom Right */}
                <div className='absolute -bottom-4 -left-4 w-8 h-8 border-b-4 border-l-4 border-gray-300 dark:border-gray-600 rounded-bl-3xl'></div>
                
                {/* Icon Circle */}
                <div className={`${card.bgColor} w-16 h-16 rounded-full flex items-center justify-center mb-6 flex-shrink-0`}>
                  {card.icon}
                </div>
                
                {/* Content */}
                <h3 className='text-xl font-bold mb-3 text-gray-900 dark:text-white'>
                  {card.title}
                </h3>
                
                <p className='text-gray-600 dark:text-gray-400 text-sm leading-relaxed mb-4'>
                  {card.description}
                </p>
                
                {/* Read More Link */}
                {/* <a href='#' className='text-blue-600 dark:text-blue-400 font-semibold hover:text-blue-800 dark:hover:text-blue-300 flex items-center gap-2'>
                  Read More <span className='text-lg'>→</span>
                </a> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicy
